export default "/images/vendor/flag-icons/flags/1x1/vn.svg?6a5f9206c51db250d8413fe4e99ba3f7";